module.exports = __webpack_public_path__ + "static/media/error_astro.e1c216a956980cec4839c2116a73e3d4.svg";